import { DateReferences } from 'src/app/models/enums/date-references';
import { DelayTypes } from 'src/app/models/enums/delay-types';
import { TimeUnits } from 'src/app/models/enums/time-units';
import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données du trigger 'minuteur'
 */
export class TimerTriggerData extends BaseTriggerData {
    /**
     * Date de réference du délai.
     */
    public dateReference: DateReferences;
    /**
     * Type de délai.
     */
    public delayType: DelayTypes;
    /**
     * Valeur du délai.
     */
    public delay: number;
    /**
     * Unité du délai.
     */
    public unit: TimeUnits;
    /**
     * Id de l'attribut contenant la date de reference.
     */
    public dateAttributeId: number;
    /**
     * Id de l'attribut contenant la valeur du délai.
     */
    public delayAttributeId: number;
    /**
     * Id de l'étape utilisée comme reference.
     */
    public stepId: number;
    /**
     * Id de l'état utilisé comme reference.
     */
    public stateId: number;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.Timer);
    }

    /**
     * Retourne une copie d'une instance de TimerTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: TimerTriggerData) {
        if (!!other) {
            const instance = new TimerTriggerData();
            instance.dateReference = other.dateReference as DateReferences;
            instance.delayType = other.delayType as DelayTypes;
            instance.delay = other.delay;
            instance.unit = other.unit as TimeUnits;
            instance.dateAttributeId = other.dateAttributeId;
            instance.delayAttributeId = other.delayAttributeId;
            instance.stepId = other.stepId;
            instance.stateId = other.stateId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
